import { useAPIRequest } from 'dataProvider/postStateData/requestStateData';
import { useAPIData } from 'hooks/useAPIData';

/**
 * Update admin
 * @returns [submit, state]
 */
export function useAPIAdminUpdate() {
    const { put, states } = useAPIRequest();

    const requestKey = 'admin.admin.update';
    const submit = (id, data) =>
        put(requestKey, `/admins/${id}`, data, x => x, {
            // TODO: Translate this
            loading: 'Updating Root Admin',
            success: 'Updating Root Admin  Succeed',
            error: 'Updating Root Admin Failed',
        });

    return [submit, states(requestKey)];
}

/**
 * Change Root Admin
 * @returns [submit, state]
 */
export function useAPIAdminChangeRoot() {
    const { put, states } = useAPIRequest();

    const requestKey = 'admin.admin.changerootadmin';
    const submit = data =>
        put(requestKey, `/admins/change-root`, data, x => x, {
            // TODO: Translate this
            loading: 'Changing Root Admin',
            success: 'Changing Root Admin Succeed',
            error: 'Changing Root Admin Failed',
        });

    return [submit, states(requestKey)];
}

/**
 * Get Admin Options
 *
 * Hits the lightweight `/admins/options` endpoint (id, name, email, phone_number
 * and role types only) — not the paginated index, hence no metaData.
 *
 * @return [fetchApi, res]
 * @example
 * const [fetchApi, res] = useAPIAdminOptions()
 * // res format: [{value: 1, label: 'Admin 1', disabled: false}]
 */
export function useAPIAdminOptions(mapper) {
    return useAPIData(
        '/admins/options',
        items => items.map(mapper ?? (item => ({ value: item.id, label: item.email }))),
        []
    );
}
